import * as React from 'react';
import { PrescriptionFormInput } from './PrescriptionFormInput.js';

const PrescriptionFormInputContainer = ({ parameter , selectedValues , showValidation , parentId , validations , onAttributeChange , isFirstItem , isLastItem , hideLabels , errorMessageId , required , side ,  })=>{
    const parameterValue = selectedValues[parameter.name];
    const isParameterValid = showValidation ? validations === null || validations === void 0 ? void 0 : validations[parameter.name] : undefined;
    return /*#__PURE__*/ React.createElement(PrescriptionFormInput, {
        side: side,
        name: parameter.name,
        parentId: parentId,
        value: parameterValue,
        isValid: isParameterValid,
        values: parameter.values,
        onChange: onAttributeChange,
        isFirstItem: isFirstItem,
        isLastItem: isLastItem,
        hideLabels: hideLabels,
        errorMessageId: errorMessageId,
        required: required
    });
};

export { PrescriptionFormInputContainer };
//# sourceMappingURL=PrescriptionFormInputContainer.js.map
